// @flow

import * as React from 'react';

import styles from './styles.scss';

type Props = {
  children: React.Node,
};

const CategoryListWrapper = (props: Props) => <div className={styles['category-links']}>{props.children}</div>;

export default CategoryListWrapper;



// WEBPACK FOOTER //
// ./src/containers/Category/ListWrapper.js